/**
 * When the user clicks a token, they may *also* have a multi-word text
 * selection active (drag-highlighted). Both Reader and VideoReader treat that
 * as "open the popover for the whole phrase as an expression".
 *
 * Returns `{ isExpression, term, displayTerm }`. If there's no meaningful
 * selection, `isExpression` is false and we use the token's own surface_form.
 *
 * Kept pure so it can be unit-tested without a browser (pass a mocked
 * `selectionText` string). In real usage, call with window.getSelection().toString().
 */
export function detectExpressionFromSelection(selectionText, fallbackToken) {
  const raw = (selectionText || '').trim();
  // Must contain a space to be "multi-word", and within a sane length range.
  const isExpression =
    raw.length > 1 && raw.length < 100 && raw.includes(' ');

  if (isExpression) {
    return { isExpression: true, term: raw, displayTerm: raw };
  }
  return {
    isExpression: false,
    term: fallbackToken?.normalized_form || '',
    displayTerm: fallbackToken?.surface_form || '',
  };
}
